"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _default = exports.default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: ['buffer', 'activePrompt'],
  data() {
    return {};
  },
  computed: {
    network() {
      return this.buffer.getNetwork();
    },
    displayName() {
      if (this.buffer.isChannel()) {
        return this.buffer.name.replace(/^[#&]+/, '');
      }
      return this.buffer.name;
    },
    isAccueil() {
      return this.buffer.name.toLowerCase().replace(/^[#&]+/, '') === 'accueil';
    },
    showPromptClose() {
      return this.activePrompt && this.activePrompt.type === 'buffer' && this.activePrompt.value === this.buffer;
    },
    queryUser() {
      if (!this.network) {
        return null;
      }
      // Lecture de usersRevision → dépendance réactive : la pastille du privé
      // se ré-évalue au join/quit (network.users est non-réactif) et repasse
      // au vert quand l'utilisateur revient.
      // eslint-disable-next-line no-unused-expressions
      this.network.usersRevision;
      return this.network.userByName(this.buffer.name);
    }
  },
  methods: {
    isActiveBuffer() {
      let buffer = this.buffer;
      return buffer.networkid === this.$state.ui.active_network && buffer.name === this.$state.ui.active_buffer;
    },
    awayNotifySupported() {
      return this.network.ircClient.network.cap.isEnabled('away-notify');
    },
    showMessageCounts() {
      return !this.buffer.setting('hide_message_counts');
    },
    maybePromptClose() {
      const setting = this.buffer.setting('prompt_leave');
      if (setting === 'none' || setting !== 'all' && (this.buffer.isChannel() && setting !== 'channels' || this.buffer.isQuery() && setting !== 'queries' || this.buffer.isSpecial() && setting !== 'queries')) {
        // Prompt feature is disabled, just close the buffer
        this.closeBuffer();
        return;
      }
      const prompt = this.activePrompt;
      if (this.showPromptClose) {
        // Prompt is currently visible so close it
        prompt.type = undefined;
        prompt.value = undefined;
      } else {
        prompt.type = 'buffer';
        prompt.value = this.buffer;
      }
    },
    closeBuffer() {
      this.$state.removeBuffer(this.buffer);
    }
  }
};